import './profileComponent.scss';
import {getDefaultAvatarUrl, UserDto} from "../../../users/model/User";
import {UserServiceName} from "../../../utils/names/serviceNames";
import {UserEventType, UserService} from "../../../users_service/service/user.service";
import {getAbsoluteUrl} from "../../../utils/urlUtill";
import {IHttpResponse, IHttpService} from "angular";

class ProfileComponent {

    private principal: UserDto;

    constructor(private $scope,
                private $http: IHttpService,
                private userService: UserService) {
        this.$scope = $scope;
        this.$http = $http;
        this.userService = userService;
        this.$scope.userProfileShown = false;
        this.$scope.toggleProfile = this.toggleProfile;
        this.$scope.handleClickOutsideComponent = this.handleClickOutsideComponent;
        this.$scope.logoutUser = this.logoutUser;
    }

    toggleProfile = ($event) => {
        this.$scope.userProfileShown = !this.$scope.userProfileShown;
        $event.stopImmediatePropagation();
    };

    handleClickOutsideComponent = () => {
        this.$scope.userProfileShown = false;
        // this.$scope.$apply();
    };

    $onInit() {
        let principal = this.principal;
        principal.avatarUrl = this.getPrincipalAvatarUrl(principal);
        this.$scope.principal = principal;
        this.userService.subscribeForUserWithIdEventsWithType(principal.id, UserEventType.UPDATED, avatarChangeEvent => {
            let updatedUser = avatarChangeEvent.value;
            principal.avatarUrl = updatedUser.avatarUrl;
        })
    }

    updateAvatarId = (principal, avatarId) => {
        (principal.avatar) && (principal.avatar.id = avatarId);
    };

    getPrincipalAvatarUrl(principal) {
        if (principal.avatar && principal.avatar.url) {
            return principal.avatar.url;
        } else {
            return getDefaultAvatarUrl(principal.gender);
        }
    }

    logoutUser = () => {
        this.$http({
            method: 'POST',
            url: getAbsoluteUrl('logout')
        }).then((resp: IHttpResponse<any>) => {
            console.log("resp ", resp)
            console.log("resp.status ", resp.status)
            if (resp.status === 200 || resp.status === 302) {
                window.location.href = getAbsoluteUrl('login');
            }
        });
    }
}

export const PROFILE_COMPONENT = {
    template: require("./profileComponent.html"),
    controller: ['$scope', '$http', UserServiceName, ProfileComponent],
    bindings: {
        'principal': '<'
    }
};
